document.addEventListener("DOMContentLoaded", function () {
    const selectedTableBody = document.getElementById("selected-components-tbody");
    const totalPriceEl = document.getElementById("total-price");
    const addToCartBtn = document.querySelector(".build-pc-cart");
    const outOfStockToggle = document.getElementById("show-out-of-stock");

    let total = 0;
    const selectedItems = [];

    function formatPrice(price) {
        const num = Number(price || 0);
        return `₹${num.toLocaleString("en-IN")}`;
    }

    function detectCategoryFromTitle(title, fallbackCategory = '') {
        title = (title || '').toLowerCase();
        let detectedCategory = (fallbackCategory || '').trim().toLowerCase();

        const categoryMap = {
            'cpu': 'cpu',
            'processor': 'cpu',
            'processors': 'cpu',
            'motherboard': 'motherboard',
            'motherboards': 'motherboard',
            'ram': 'ram',
            'solid state drive (ssd)': 'storage1',
            'hard disk (hdd)': 'storage2',
            'storage 1': 'storage1',
            'storage 2': 'storage2',
            'graphic cards': 'gpu',
            'graphics card': 'gpu',
            'graphics cards': 'gpu',
            'gpu': 'gpu',
            'power supply unit': 'psu',
            'power supply': 'psu',
            'psu': 'psu',
            'smps': 'psu',
            'cabinet': 'cabinet',
            'case': 'cabinet',
            'cases': 'cabinet',
            'cooler': 'cooler',
            'coolers': 'cooler',
            'optionals': 'optional',
            'optional': 'optional'
        };

        if (detectedCategory && categoryMap[detectedCategory]) {
            return categoryMap[detectedCategory];
        }

        if (title.includes("solid state drive") || title.includes("ssd")) return "storage1";
        if (title.includes("hard disk") || title.includes("hdd")) return "storage2";
        if (title.includes("ryzen") || title.includes("intel core") || title.includes("processor")) return "cpu";
        if (title.includes("motherboard") || title.includes("chipset") || title.includes("b450") || title.includes("b550") || title.includes("b650") || title.includes("z790") || title.includes("h610")) return "motherboard";
        if (title.includes("ram") || title.includes("ddr")) return "ram";
        if (title.includes("power supply") || title.includes("psu") || title.includes("smps")) return "psu";
        if (title.includes("cabinet") || title.includes("case") || title.includes("chassis")) return "cabinet";
        if (title.includes("cooler") || title.includes("liquid") || title.includes("fan") || title.includes("aio")) return "cooler";
        if (title.includes("graphic card") || title.includes("graphics card") || title.includes("gpu") || title.includes("rtx") || title.includes("gtx") || title.includes("radeon")) return "gpu";

        return "other";
    }

    function getSelectedAttribute(category, attribute) {
        const item = selectedItems.find(i => i.category.toLowerCase() === category.toLowerCase());
        return item ? item[attribute] : null;
    }

    function compatible(card, sectionCategory) {
        const cardSocket = (card.dataset.socket || "").toLowerCase().trim();
        const cardRam = (card.dataset.ram || "").toLowerCase().trim();
        const cardFormFactor = (card.dataset.factor || "").trim().toLowerCase();
        const cardCoolerHeight = (card.dataset.cooler || "").trim();
        const cardGpuLength = (card.dataset.gpu || "").trim();
        const cardPsuWattage = (card.dataset.psu || "").trim();

        const selectedCPUSocket = getSelectedAttribute("cpu", "socket");
        const selectedMotherboardSocket = getSelectedAttribute("motherboard", "socket");
        const selectedMotherboardRam = getSelectedAttribute("motherboard", "ram");
        const selectedMotherboardFormFactor = (getSelectedAttribute("motherboard", "factor") || "").trim().toLowerCase();
        const selectedCoolerHeight = getSelectedAttribute("cabinet", "cooler");
        const selectedGpuLength = getSelectedAttribute("cabinet", "gpu");
        const selectedGpuWattage = getSelectedAttribute("gpu", "psu");

        if (sectionCategory === "motherboard" && selectedCPUSocket) {
            return cardSocket === selectedCPUSocket;
        }

        if (sectionCategory === "cpu" && selectedMotherboardSocket) {
            return cardSocket === selectedMotherboardSocket;
        }

        if (sectionCategory === "ram" && selectedMotherboardRam) {
            return cardRam === selectedMotherboardRam;
        }

        if (sectionCategory === "cabinet" && selectedMotherboardFormFactor) {
            return cardFormFactor
                ? cardFormFactor.split(',').map(s => s.trim()).includes(selectedMotherboardFormFactor)
                : true;
        }

        if (sectionCategory === "cooler" && selectedCoolerHeight) {
            return cardCoolerHeight ? parseFloat(cardCoolerHeight) <= parseFloat(selectedCoolerHeight) : true;
        }

        if (sectionCategory === "gpu" && selectedGpuLength) {
            return cardGpuLength ? parseFloat(cardGpuLength) <= parseFloat(selectedGpuLength) : true;
        }

        if (sectionCategory === "psu" && selectedGpuWattage) {
            return cardPsuWattage ? parseFloat(cardPsuWattage) >= parseFloat(selectedGpuWattage) : true;
        }

        return true;
    }

    function refreshAllOpenSections() {
        document.querySelectorAll('.builder-section').forEach(sec => {
            const content = sec.querySelector('.builder-content');
            if (content && !content.classList.contains('hidden')) {
                if (typeof sec.updateBrands === 'function') sec.updateBrands();
                if (typeof sec.updateTypes === 'function') sec.updateTypes();
                if (typeof sec.refresh === 'function') sec.refresh();
            }
        });
    }

    function updateTotal() {
        total = selectedItems.reduce((sum, item) => {
            return sum + (Number(item.price || 0) * Number(item.quantity || 1));
        }, 0);

        if (totalPriceEl) totalPriceEl.textContent = formatPrice(total);
    }

    document.body.addEventListener("click", (event) => {
        const btn = event.target.closest('.builder-toggle');
        if (!btn) return;

        let content = btn.nextElementSibling;

        if (!content || !content.classList || !content.classList.contains('builder-content')) {
            const section = btn.closest('.builder-section');
            content = section ? section.querySelector('.builder-content') : null;
        }

        if (!content) return;

        content.classList.toggle('hidden');

        const icon = btn.querySelector(".builder-icon");
        if (icon) {
            icon.textContent = content.classList.contains('hidden') ? "+" : "✖";
        }

        const section = btn.closest('.builder-section');
        if (section && !content.classList.contains('hidden')) {
            if (typeof section.updateBrands === 'function') section.updateBrands();
            if (typeof section.updateTypes === 'function') section.updateTypes();
            if (typeof section.refresh === 'function') section.refresh();
        }
    });

    document.querySelectorAll('.builder-qty-wrapper').forEach(wrapper => {
        const minusBtn = wrapper.querySelector('.qty-btn.minus');
        const plusBtn = wrapper.querySelector('.qty-btn.plus');
        const input = wrapper.querySelector('input.qty');

        if (!minusBtn || !plusBtn || !input) return;

        minusBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value || 1, 10);
            if (currentValue > 1) input.value = currentValue - 1;
        });

        plusBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value || 1, 10);
            input.value = currentValue + 1;
        });

        input.addEventListener('input', () => {
            if (parseInt(input.value || 1, 10) < 1) input.value = 1;
        });
    });

    document.querySelectorAll(".add-to-build").forEach(button => {
        button.addEventListener("click", () => {
            const title = button.dataset.title || '';
            const price = parseFloat((button.dataset.price || '0').replace(/[^\d.-]/g, '')) || 0;
            const variantId = String(button.dataset.id || '');
            const image = button.dataset.image || '';
            const wrapper = button.closest('.product-row') || button.closest('.builder-qty-wrapper');
            const input = wrapper?.querySelector('input.qty');
            const quantity = input ? Math.max(1, parseInt(input.value || '1', 10)) : 1;

            const socket = (button.dataset.socket || "").toLowerCase().trim();
            const ram = (button.dataset.ram || "").toLowerCase().trim();
            const factor = (button.dataset.factor || "").toLowerCase().trim();
            const cooler = (button.dataset.cooler || "").trim();
            const gpu = (button.dataset.gpu || "").trim();
            const psu = (button.dataset.psu || "").trim();
            const category = (button.dataset.category || '').trim().toLowerCase() || detectCategoryFromTitle(title, button.dataset.category);

            const existingIndex = selectedItems.findIndex(item => String(item.id) === variantId);

            if (existingIndex !== -1) {
                selectedItems.splice(existingIndex, 1);

                const row = selectedTableBody.querySelector(`tr[data-id="${CSS.escape(variantId)}"]`);
                if (row) selectedTableBody.removeChild(row);

                updateTotal();

                button.textContent = "Add To List";
                button.classList.remove("added");

                refreshAllOpenSections();
                return;
            }

            const selectedCPUSocket = getSelectedAttribute("cpu", "socket");
            const selectedMotherboardSocket = getSelectedAttribute("motherboard", "socket");
            const selectedMotherboardRam = getSelectedAttribute("motherboard", "ram");
            const selectedMotherboardFormFactor = getSelectedAttribute("motherboard", "factor");
            const selectedCoolerHeight = getSelectedAttribute("cabinet", "cooler");
            const selectedGpuLength = getSelectedAttribute("cabinet", "gpu");
            const selectedGpuWattage = getSelectedAttribute("gpu", "psu");

            if (category === "motherboard" && selectedCPUSocket && socket && socket !== selectedCPUSocket) {
                alert(`This motherboard is incompatible with the selected CPU (socket: ${selectedCPUSocket}).`);
                return;
            }

            if (category === "cpu" && selectedMotherboardSocket && socket && socket !== selectedMotherboardSocket) {
                alert(`This CPU is incompatible with the selected motherboard (socket: ${selectedMotherboardSocket}).`);
                return;
            }

            if (category === "ram" && selectedMotherboardRam && ram && ram !== selectedMotherboardRam) {
                alert(`This RAM is incompatible with the selected motherboard (RAM type: ${selectedMotherboardRam}).`);
                return;
            }

            if (category === "cabinet" && selectedMotherboardFormFactor && factor) {
                const supportedFactors = factor.split(',').map(s => s.trim());
                if (!supportedFactors.includes(String(selectedMotherboardFormFactor).trim().toLowerCase())) {
                    alert(`This cabinet is incompatible with the selected motherboard (form factor: ${selectedMotherboardFormFactor}).`);
                    return;
                }
            }

            if (category === "cooler" && cooler && selectedCoolerHeight && parseFloat(cooler) > parseFloat(selectedCoolerHeight)) {
                alert(`This cooler is incompatible with the selected cabinet (max cooler height: ${selectedCoolerHeight} mm).`);
                return;
            }

            if (category === "gpu" && gpu && selectedGpuLength && parseFloat(gpu) > parseFloat(selectedGpuLength)) {
                alert(`This GPU is incompatible with the selected cabinet (max GPU length: ${selectedGpuLength} mm).`);
                return;
            }

            if (category === "psu" && psu && selectedGpuWattage && parseFloat(psu) < parseFloat(selectedGpuWattage)) {
                alert(`This PSU is incompatible with the selected GPU (minimum wattage: ${selectedGpuWattage} W).`);
                return;
            }

            if (
                ["cpu", "motherboard", "cabinet", "gpu", "psu", "cooler", "storage1", "storage2"].includes(category) &&
                selectedItems.some(item => item.category === category)
            ) {
                alert(`Only one ${category.toUpperCase()} can be selected.`);
                return;
            }

            const row = document.createElement("tr");
            row.innerHTML = `
                <td>${category.toUpperCase()}</td>
                <td><img src="${image}" alt="${title}" style="width:50px;height:50px;object-fit:contain;"></td>
                <td>${title}</td>
                <td>${formatPrice(price)}</td>
                <td>${quantity}</td>
                <td><button class="pc-build remove-btn" data-id="${variantId}">Remove</button></td>
            `;
            row.dataset.id = variantId;
            row.dataset.price = String(price);
            row.dataset.qty = String(quantity);
            row.dataset.category = category;

            selectedTableBody.appendChild(row);

            selectedItems.push({
                id: variantId,
                title,
                image,
                price,
                quantity,
                category,
                socket,
                ram,
                factor,
                cooler,
                gpu,
                psu
            });

            updateTotal();

            button.textContent = "Remove from List";
            button.classList.add("added");

            refreshAllOpenSections();
        });
    });

    if (selectedTableBody) {
        selectedTableBody.addEventListener("click", (event) => {
            const removeBtn = event.target.closest(".remove-btn");
            if (!removeBtn) return;

            const variantId = String(removeBtn.dataset.id || '');
            const row = removeBtn.closest("tr");

            const itemIndex = selectedItems.findIndex(item => String(item.id) === variantId);
            if (itemIndex !== -1) {
                selectedItems.splice(itemIndex, 1);
            }

            if (row) selectedTableBody.removeChild(row);

            updateTotal();

            const addButton = document.querySelector(`.add-to-build[data-id="${CSS.escape(variantId)}"]`);
            if (addButton) {
                addButton.textContent = "Add To List";
                addButton.classList.remove("added");
            }

            refreshAllOpenSections();
        });
    }

    if (addToCartBtn) {
        addToCartBtn.addEventListener("click", () => {
            if (selectedItems.length === 0) {
                alert("Add some items before going to cart.");
                return;
            }

            const items = selectedItems.map(item => ({
                id: Number(item.id),
                quantity: Number(item.quantity || 1)
            }));

            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items })
            })
                .then(res => {
                    if (!res.ok) throw new Error("Cart add failed");
                    return res.json();
                })
                .then(() => {
                    window.location.href = "/cart";
                })
                .catch(err => {
                    alert("Something went wrong while adding items to cart.");
                    console.error(err);
                });
        });
    }

    document.querySelectorAll('.builder-section').forEach(section => {
        const searchInput = section.querySelector('.search-bar');
        const brandSelect = section.querySelector('.brand-filter');
        const typeSelect = section.querySelector('.type-filter');
        const sortSelect = section.querySelector('.sort-by');
        const productList = section.querySelector('.component-table tbody');

        if (!productList) return;

        const cards = Array.from(productList.querySelectorAll('.product-row'));
        let displayLimit = 6;

        const sectionCategory = (section.dataset.category || '').trim().toLowerCase() ||
            detectCategoryFromTitle(section.querySelector('.builder-toggle')?.textContent || '', section.dataset.category);

        if (brandSelect) {
            brandSelect.innerHTML = `<option value="">Choose A Brand</option>`;
            const initialBrands = new Set();
            cards.forEach(card => {
                const brand = (card.dataset.brand || '').trim();
                if (brand) initialBrands.add(brand);
            });
            [...initialBrands].sort().forEach(brand => {
                brandSelect.appendChild(new Option(brand, brand));
            });
        }

        const updateBrands = () => {
            if (!brandSelect) return;

            const showOutOfStock = outOfStockToggle ? outOfStockToggle.checked : false;
            const filteredBrands = new Set();

            cards.forEach(card => {
                const brand = (card.dataset.brand || '').trim();
                const isOutOfStock = card.classList.contains('out-of-stock');
                const matchStock = showOutOfStock || !isOutOfStock;

                if (brand && compatible(card, sectionCategory) && matchStock) {
                    filteredBrands.add(brand);
                }
            });

            const previousValue = brandSelect.value;
            brandSelect.innerHTML = `<option value="">Choose A Brand</option>`;

            [...filteredBrands].sort().forEach(brand => {
                const option = new Option(brand, brand);
                if (brand === previousValue) option.selected = true;
                brandSelect.appendChild(option);
            });
        };

        const updateTypes = () => {
            if (!typeSelect) return;

            const selectedBrand = (brandSelect?.value || '').trim().toLowerCase();
            const showOutOfStock = outOfStockToggle ? outOfStockToggle.checked : false;
            const filteredTypes = new Set();

            cards.forEach(card => {
                const brand = (card.dataset.brand || '').trim().toLowerCase();
                const type = (card.dataset.type || '').trim();
                const isOutOfStock = card.classList.contains('out-of-stock');
                const matchesBrand = !selectedBrand || brand === selectedBrand;
                const matchStock = showOutOfStock || !isOutOfStock;

                if (type && compatible(card, sectionCategory) && matchesBrand && matchStock) {
                    filteredTypes.add(type);
                }
            });

            const previousValue = typeSelect.value;
            typeSelect.innerHTML = `<option value="">Choose your type</option>`;

            [...filteredTypes].sort().forEach(type => {
                const option = new Option(type, type);
                if (type === previousValue) option.selected = true;
                typeSelect.appendChild(option);
            });
        };

        const refreshProductList = () => {
            const searchTerm = (searchInput?.value || '').toLowerCase().trim();
            const selectedBrand = (brandSelect?.value || '').trim().toLowerCase();
            const selectedType = (typeSelect?.value || '').trim().toLowerCase();
            const sortType = sortSelect?.value || '';
            const showOutOfStock = outOfStockToggle ? outOfStockToggle.checked : false;

            let matchedCards = cards.filter(card => {
                const title = (card.dataset.title || '').toLowerCase();
                const brand = (card.dataset.brand || '').toLowerCase();
                const type = (card.dataset.type || '').toLowerCase();
                const isOutOfStock = card.classList.contains('out-of-stock');

                const matchSearch = title.includes(searchTerm);
                const matchBrand = !selectedBrand || brand === selectedBrand;
                const matchType = !selectedType || type === selectedType;
                const matchStock = showOutOfStock || !isOutOfStock;
                const isCompatible = compatible(card, sectionCategory);

                return matchSearch && matchBrand && matchType && matchStock && isCompatible;
            });

            if (sortType) {
                const compare = {
                    "name-asc": (a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || ''),
                    "price-asc": (a, b) => parseFloat(a.dataset.price || '0') - parseFloat(b.dataset.price || '0'),
                    "price-desc": (a, b) => parseFloat(b.dataset.price || '0') - parseFloat(a.dataset.price || '0')
                }[sortType];

                if (compare) matchedCards.sort(compare);
            }

            cards.forEach(card => card.style.display = "none");
            matchedCards.slice(0, displayLimit).forEach(card => card.style.display = "table-row");

            const seeMoreBtn = section.querySelector(".see-more-btn");
            if (seeMoreBtn) {
                seeMoreBtn.style.display = matchedCards.length > displayLimit ? "inline-block" : "none";
            }
        };

        section.updateBrands = updateBrands;
        section.updateTypes = updateTypes;
        section.refresh = refreshProductList;

        if (brandSelect) {
            brandSelect.addEventListener('change', () => {
                updateTypes();
                refreshProductList();
            });
        }

        [searchInput, typeSelect, sortSelect].forEach(el => {
            el?.addEventListener("input", refreshProductList);
            el?.addEventListener("change", refreshProductList);
        });

        const seeMoreBtn = section.querySelector(".see-more-btn");
        if (seeMoreBtn) {
            seeMoreBtn.addEventListener('click', () => {
                displayLimit += 6;
                refreshProductList();
            });
        }
    });

    if (outOfStockToggle) {
        document.querySelectorAll('.product-row.out-of-stock').forEach(row => row.style.display = 'none');

        outOfStockToggle.addEventListener('change', () => {
            refreshAllOpenSections();
        });
    }
});

// =========================
// PDF DOWNLOAD
// =========================
(function () {
    async function imageToDataURL(url) {
        return new Promise((resolve) => {
            if (!url) return resolve(null);

            const img = new Image();
            img.crossOrigin = "Anonymous";

            img.onload = function () {
                try {
                    const canvas = document.createElement("canvas");
                    canvas.width = this.naturalWidth;
                    canvas.height = this.naturalHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(this, 0, 0);
                    resolve(canvas.toDataURL("image/jpeg", 0.9));
                } catch (err) {
                    console.warn("Image convert failed:", err);
                    resolve(null);
                }
            };

            img.onerror = function () {
                console.warn("Image load failed:", url);
                resolve(null);
            };

            img.src = url;
        });
    }

    function initPdfDownload() {
        const button = document.getElementById("download-pdf");
        if (!button) {
            console.error("PDF button not found");
            return;
        }

        button.addEventListener("click", async function (e) {
            e.preventDefault();
            console.log("PDF button clicked");

            const tableBody = document.getElementById("selected-components-tbody");
            const totalEl = document.getElementById("total-price");

            if (!tableBody || !tableBody.querySelector("tr")) {
                alert("Please add some components before downloading the PDF.");
                return;
            }

            if (!window.jspdf || !window.jspdf.jsPDF) {
                alert("jsPDF library is not loaded.");
                console.error("window.jspdf missing");
                return;
            }

            try {
                const { jsPDF } = window.jspdf;
                const doc = new jsPDF("p", "mm", "a4");

                let y = 15;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();

                function moneyText(value) {
                    const num = Number(String(value).replace(/[^\d.]/g, "")) || 0;
                    return "INR " + num.toLocaleString("en-IN");
                }

                // Header
                doc.setFont("helvetica", "bold");
                doc.setFontSize(16);
                doc.text("Vishal Peripherals", 14, y);

                doc.setFont("helvetica", "normal");
                doc.setFontSize(9);
                doc.text("Website: www.vishalperipherals.com", 14, y + 6);
                doc.text("Phone: +91 XXXXXXXXXX", 14, y + 11);
                doc.text("Address: Hyderabad, Telangana", 14, y + 16);

                y += 28;

                doc.setFont("helvetica", "bold");
                doc.setFontSize(13);
                doc.text("PC Build Summary", pageWidth / 2, y, { align: "center" });

                y += 8;

                // Table header
                doc.setFont("helvetica", "bold");
                doc.setFontSize(9);

                doc.rect(10, y, 24, 10);   // Category
                doc.rect(34, y, 22, 10);   // Image
                doc.rect(56, y, 74, 10);   // Product
                doc.rect(130, y, 18, 10);  // Qty
                doc.rect(148, y, 28, 10);  // Price
                doc.rect(176, y, 24, 10);  // Subtotal

                doc.text("Category", 12, y + 6);
                doc.text("Image", 39, y + 6);
                doc.text("Product", 58, y + 6);
                doc.text("Qty", 136, y + 6);
                doc.text("Price", 154, y + 6);
                doc.text("Total", 180, y + 6);

                y += 10;

                const rows = tableBody.querySelectorAll("tr");

                for (const row of rows) {
                    const cols = row.querySelectorAll("td");
                    if (cols.length < 6) continue;

                    const category = cols[0].innerText.trim();
                    const imgEl = cols[1].querySelector("img");
                    const product = cols[2].innerText.trim();
                    const price = cols[3].innerText.trim();
                    const qty = cols[4].innerText.trim();

                    const qtyNum = Number(qty) || 1;
                    const priceNum = Number(String(price).replace(/[^\d.]/g, "")) || 0;
                    const subtotal = priceNum * qtyNum;

                    const productLines = doc.splitTextToSize(product, 70);
                    const rowHeight = Math.max(22, productLines.length * 5 + 6);

                    if (y + rowHeight > 280) {
                        doc.addPage();
                        y = 15;
                    }

                    doc.rect(10, y, 24, rowHeight);
                    doc.rect(34, y, 22, rowHeight);
                    doc.rect(56, y, 74, rowHeight);
                    doc.rect(130, y, 18, rowHeight);
                    doc.rect(148, y, 28, rowHeight);
                    doc.rect(176, y, 24, rowHeight);

                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(8);

                    doc.text(doc.splitTextToSize(category, 20), 12, y + 5);
                    doc.text(productLines, 58, y + 5);
                    doc.text(String(qtyNum), 136, y + 5);
                    doc.text(moneyText(priceNum), 150, y + 5);
                    doc.text(moneyText(subtotal), 178, y + 5);

                    // Product image
                    if (imgEl && imgEl.src) {
                        const dataUrl = await imageToDataURL(imgEl.src);
                        if (dataUrl) {
                            try {
                                doc.addImage(dataUrl, "JPEG", 37, y + 3, 16, 16);
                            } catch (err) {
                                console.warn("Image add failed:", err);
                            }
                        }
                    }

                    y += rowHeight;
                }

                y += 8;
                if (y > 285) {
                    doc.addPage();
                    y = 15;
                }

                doc.setFont("helvetica", "bold");
                doc.setFontSize(11);
                doc.text("Total Build Cost: " + (totalEl ? totalEl.innerText.trim().replace("₹", "INR ") : "INR 0"), 14, y);

                doc.setFont("helvetica", "normal");
                doc.setFontSize(9);
                doc.text(
                    "www.vishalperipherals.com | Call Us: +91 XXXXXXXXXX | Hyderabad, Telangana",
                    pageWidth / 2,
                    pageHeight - 10,
                    { align: "center" }
                );

                doc.save("vishal-pc-build-summary.pdf");
                console.log("PDF generated successfully");
            } catch (err) {
                console.error("PDF generation failed", err);
                alert("PDF generation failed. Check console.");
            }
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initPdfDownload);
    } else {
        initPdfDownload();
    }
})();